import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { FaChevronDown, FaChevronUp, FaSignOutAlt } from "react-icons/fa";
import { getMe, logoutUser } from "../services/apiService";
import "./Sidebar.css";

const ROLE_PERMISSIONS = {
  1: ["dashboard", "stock_list", "sales_order", "reports", "users"],
  2: ["dashboard", "stock_list", "sales_order", "reports"],

  3: [
    "dashboard",
    "reagents",
    "suppliers",
    "sales_order",
    "logistics_so",
    "barcode_info",
    "delivery_notes",
    "stock_receiving",
    "receive_po",
    "opening_stock",
    "stock_list",
    "Transfer",
    "reports",
    // "manual_out"
    // "users",
  ],

  4: [
    "dashboard",
    "reagents",
    "suppliers",
    "sales_order",
    "logistics_so",
    "delivery_notes",
    "stock_receiving",
    "receive_po",
    "barcode_info",
    "opening_stock",
    "stock_list",
    "Transfer",
    "reports",
    // "manual_out"
    // "users",
  ],

  5: [
    "dashboard",
    // "reagents",
    // "suppliers",
    // "clients",
    "sales_person",
    "sales_order",
    "stock_receiving",
    "barcode_info",
    "receive_po",
    "stock_list",
    "Transfer",
    "reports",
    "delivery_notes",
    // "users",
  ],

  6: [
    "dashboard",
    "stock_list",
    "reagents",
    "suppliers",
    "purchase_orders",
    "receive_po",
    "reports",
    // "users",
  ],

  7: [
    "dashboard",
    "stock_list",
    "suppliers",
    "logistics_so",
    "reports",
    // "users",
  ],

  8: ["dashboard", "stock_list", "sales_order", "logistics_so", "reports"],
  9: ["dashboard", "stock_list", "sales_order", "reports"],
  10: ["dashboard", "stock_list", "sales_order"],
  11: ["dashboard", "stock_list", "sales_order"],

  12: ["ALL"], // SUPER ADMIN
  13: ["dashboard", "stock_list", "sales_order", "reports"], //managers
  14: ["ALL"], //execom
  15: ["dashboard", "stock_list", "sales_order", "logistics_so", "delivery_notes", "reports"],
  16: ["dashboard", "stock_list", "sales_order"],
  17: ["dashboard", "stock_list", "sales_order"],
};

function Sidebar() {
  const [activeMenu, setActiveMenu] = useState("");
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [roleID, setRoleID] = useState(null);

  useEffect(() => {
    getMe()
      .then((res) => {
        setIsLoggedIn(true);
        setRoleID(Number(res?.RoleID) || null);
      })
      .catch((err) => {
        console.error("SIDEBAR GETME ERROR:", err);
        setIsLoggedIn(false);
        setRoleID(null);
      });
  }, []);

  const hasAccess = (key) => {
    if (!roleID) return false;
    const perms = ROLE_PERMISSIONS[roleID] || [];
    return perms.includes("ALL") || perms.includes(key);
  };

  const handleLogout = async () => {
    try {
      await logoutUser();
    } catch (err) {
      console.error("LOGOUT ERROR:", err);
      window.location.href = "/login";
    }
  };

  const toggleMenu = (menu) => {
    setActiveMenu((prev) => (prev === menu ? "" : menu));
  };

  return (
    <aside className="sidebar">
      <div className="sidebar-header">
        <img src="/img/logo.png" alt="Biocare Logo" className="header-logo" />
        <h2 className="logo-text">IMS</h2>

        {isLoggedIn && (
          <button className="logout-btn" onClick={handleLogout} title="Logout">
            <FaSignOutAlt />
          </button>
        )}
      </div>

      {!isLoggedIn ? null : (
        <>
          {hasAccess("dashboard") && (
            <NavLink to="/" className="main-link">
              Dashboard
            </NavLink>
          )}

          {(hasAccess("users") ||
            hasAccess("reagents") ||
            hasAccess("suppliers") ||
            hasAccess("clients") ||
            hasAccess("sales_person") ||
            hasAccess("warehouse")) && (
              <div>
                <div className="menu-header" onClick={() => toggleMenu("add")}>
                  ADD DATA
                  {activeMenu === "add" ? <FaChevronUp /> : <FaChevronDown />}
                </div>

                <div className={`dropdown ${activeMenu === "add" ? "open" : ""}`}>
                  {hasAccess("users") && (
                    <NavLink to="/users" className="sub-link">
                      Users
                    </NavLink>
                  )}

                  {hasAccess("reagents") && (
                    <NavLink to="/items" className="sub-link">
                      Reagents
                    </NavLink>
                  )}

                  {hasAccess("suppliers") && (
                    <NavLink to="/suppliers" className="sub-link">
                      Suppliers
                    </NavLink>
                  )}

                  {hasAccess("clients") && (
                    <NavLink to="/customers" className="sub-link">
                      Client
                    </NavLink>
                  )}

                  {hasAccess("sales_person") && (
                    <NavLink to="/sales-person" className="sub-link">
                      Sales Person
                    </NavLink>
                  )}

                  {hasAccess("warehouse") && (
                    <NavLink to="/warehouse" className="sub-link">
                      Warehouse
                    </NavLink>
                  )}
                </div>
              </div>
            )}

          {(hasAccess("purchase_orders") || hasAccess("receive_po")) && (
            <div>
              <div className="menu-header" onClick={() => toggleMenu("pos")}>
                POS
                {activeMenu === "pos" ? <FaChevronUp /> : <FaChevronDown />}
              </div>

              <div className={`dropdown ${activeMenu === "pos" ? "open" : ""}`}>
                {hasAccess("purchase_orders") && (
                  <NavLink to="/po" className="sub-link">
                    Purchase Orders
                  </NavLink>
                )}

                {hasAccess("receive_po") && (
                  <NavLink to="/receiving-po" className="sub-link">
                    Receive PO
                  </NavLink>
                )}
              </div>
            </div>
          )}

          {(hasAccess("stock_receiving") ||
            hasAccess("stock_list") ||
            hasAccess("barcode_info") ||
            hasAccess("opening_stock") ||
            hasAccess("Transfer") ||
            hasAccess("manual_out")) && (
              <div>
                <div className="menu-header" onClick={() => toggleMenu("stock")}>
                  STOCK
                  {activeMenu === "stock" ? <FaChevronUp /> : <FaChevronDown />}
                </div>

                <div className={`dropdown ${activeMenu === "stock" ? "open" : ""}`}>
                  {hasAccess("stock_receiving") && (
                    <NavLink to="/stock-receiving" className="sub-link">
                      Stock Receiving
                    </NavLink>
                  )}

                  {hasAccess("stock_list") && (
                    <NavLink to="/stock-list" className="sub-link">
                      Stock List
                    </NavLink>
                  )}

                  {hasAccess("barcode_info") && (
                    <NavLink to="/barcode-information" className="sub-link">
                      Barcode Information
                    </NavLink>
                  )}

                  {hasAccess("opening_stock") && (
                    <NavLink to="/opening-stock" className="sub-link">
                      Opening Stock
                    </NavLink>
                  )}

                  {hasAccess("Transfer") && (
                    <NavLink to="/stock-transfer" className="sub-link">
                      Stock Transfer
                    </NavLink>
                  )}

                  {hasAccess("manual_out") && (
                    <NavLink to="/manual-stock-out" className="sub-link">
                      Manual Stock Out
                    </NavLink>
                  )}
                </div>
              </div>
            )}

          {(hasAccess("sales_order") ||
            hasAccess("logistics_so") ||
            hasAccess("delivery_notes")) && (
              <div>
                <div className="menu-header" onClick={() => toggleMenu("so")}>
                  SO
                  {activeMenu === "so" ? <FaChevronUp /> : <FaChevronDown />}
                </div>

                <div className={`dropdown ${activeMenu === "so" ? "open" : ""}`}>
                  {hasAccess("sales_order") && (
                    <NavLink to="/so" className="sub-link">
                      Sales Order
                    </NavLink>
                  )}

                  {hasAccess("logistics_so") && (
                    <NavLink to="/sales-orders-logistics" className="sub-link">
                      Logistics SO
                    </NavLink>
                  )}

                  {hasAccess("delivery_notes") && (
                    <NavLink to="/delivery-notes" className="sub-link">
                      Delivery Notes
                    </NavLink>
                  )}
                </div>
              </div>
            )}

          {hasAccess("reports") && (
            <NavLink to="/reports" className="main-link">
              Reports
            </NavLink>
          )}
        </>
      )}

      {isLoggedIn && (
        <div className="sidebar-logo-container">
          <img
            src="/img/footer-logo.png"
            alt="Biocare Logo"
            className="sidebar-logo"
          />
        </div>
      )}
    </aside>
  );
}

export default Sidebar;